import React from 'react'
import { Form } from '@pinchenterprisesnpm/friday-ui'
import { Col } from 'styled-bootstrap-grid'
import GenericTooltip from 'ui/components/common/GenericTooltip'
import { Label, MainContainer, LabelAndTooltipWrapper } from './style'
const { Checkbox } = Form

export type ColumnType = true | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
export type OffsetType = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11

type ClaimCheckboxProps = {
  label: string
  name: string
  value: boolean
  handleChange: (field: string, value: any) => void
  tooltipMessage?: string
  isDisabled?: boolean
}

const ClaimCheckbox = (props: ClaimCheckboxProps) => {
  const { label, name, value, handleChange, tooltipMessage, isDisabled = false } = props
  return (
    <Col>
      <MainContainer>
        <Checkbox
          isDisabled={isDisabled}
          name={name}
          value={value}
          onChange={(e: boolean, rest: React.ChangeEvent<HTMLInputElement>) => {
            handleChange(rest.target.name, e)
          }}
        />
        <LabelAndTooltipWrapper>
          <Label>{label}</Label>
          {tooltipMessage && <GenericTooltip message={tooltipMessage} />}
        </LabelAndTooltipWrapper>
      </MainContainer>
    </Col>
  )
}

export default ClaimCheckbox
